import { UnknownIntent } from '@debbie/common/dist/intents/index.js';
export const emailInitialState = {
    content: '<p></p>',
    subject: '<p></p>',
    to: '',
    from: '',
    loading: false,
    templateName: '',
    templateId: '',
    intent: UnknownIntent(),
};
export const letterInitialState = {
    content: '<p></p>',
    templateId: '',
    templateName: '',
    templateFileName: '',
    letterTo: '',
    loading: false,
    intent: UnknownIntent(),
};
export const eboksInitialState = {
    content: '<p></p>',
    subject: '<p></p>',
    templateId: '',
    templateName: '',
    loading: false,
    intent: UnknownIntent(),
};
// Kivra and Digipost carry the same digital-post shape as e-Boks
export const kivraInitialState = { ...eboksInitialState };
export const digipostInitialState = { ...eboksInitialState };
export const phoneInitialState = {
    content: '',
    phone: null,
    tags: [],
    loading: false,
    direction: null,
};
export const smsInitialState = {
    content: '',
    templateId: '',
    templateName: '',
    loading: false,
    intent: UnknownIntent(),
};
export const autocallInitialState = {
    countryCode: 45,
    content: '',
    templateId: '',
    templateName: '',
    loading: false,
    toNumber: '',
    actions: [],
};
export const noteInitialState = {
    content: '<p></p>',
    templateId: '',
    templateName: '',
    loading: false,
    attachements: [],
};
export const initialState = {
    letter: letterInitialState,
    eboks: eboksInitialState,
    kivra: kivraInitialState,
    digipost: digipostInitialState,
    note: noteInitialState,
    phone: phoneInitialState,
    sms: smsInitialState,
    autocall: autocallInitialState,
    email: emailInitialState,
    uploadQueue: [],
    uploadedFiles: [],
};
//# sourceMappingURL=types.js.map